import {useMutation, useQueryClient} from '@tanstack/react-query';
import {LoginApi} from '../../../apis/LoginApi/LoginApi.ts';
import i18n from 'i18next';
import {QueryKeys} from '../../../queryDefaults/QueryKeys';

export function usePostSetLanguageMutation() {
  const queryClient = useQueryClient();

  return useMutation<string, Error, { language: string }>({
    mutationFn: async ({language}) => {
      await LoginApi.setLanguage({language});
      return language
    },
    onSuccess: (language) => {
      if (language) {
        i18n.changeLanguage(language);
        localStorage.setItem('i18nextLng', language);
      }
      queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionalNew] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionals] });
    },
    onError: (error) => {
      return error.message;
    },
  });
}
